import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import './price.css';

const CustomPrice = ({ data, dateType, group }) => {
    return (
        <div>
            {Array.isArray(data) &&
                data.length > 0 &&
                data.map((customPriceItem) => {
                    return (
                        <div className='priceDetailsContainer'>
                            <TripDetailsSubHeading text={customPriceItem?.startCity} />
                            <div className='priceDetailsDiv'>
                                <span className='priceDetailsSpan'>
                                    <strong>Price per Person: </strong>
                                    &#8377;{customPriceItem?.customPrice?.perPerson}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Group Price: </strong>
                                    &#8377;{customPriceItem?.customPrice?.groupPrice}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Room Price: </strong>
                                    &#8377;{customPriceItem?.customPrice?.room}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Bed Price: </strong>
                                    &#8377;{customPriceItem?.customPrice?.bed}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Reserve: </strong>
                                    &#8377;{customPriceItem?.customPrice?.reserve}
                                </span>
                                <>
                                    <span className='priceDetailsSpan'>
                                        <strong>Meetup Location:</strong>
                                    </span>

                                    <ul className=''>
                                        {customPriceItem?.meetupPoint?.length > 0 &&
                                            customPriceItem?.meetupPoint?.map((locItem) => {
                                                return (
                                                    <li key={locItem?._id}>
                                                        <span className='priceDetailsSpan'>{locItem?.name}</span>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </>
                                <span className='priceDetailsSpan'>
                                    <strong>Available Vehicles:</strong>
                                </span>
                                <ul className=''>
                                    {customPriceItem?.customPrice?.vehicle?.map((vehicleItem) => {
                                        return (
                                            <li key={vehicleItem?._id}>
                                                <span className='priceDetailsSpan'>{vehicleItem?.name}</span>
                                                <span className='priceDetailsSpan'>
                                                    <strong>Price: </strong> &#8377;{vehicleItem?.price}
                                                </span>
                                                <span className='priceDetailsSpan'>
                                                    <strong>No of Seats: </strong>
                                                    {vehicleItem?.seats}
                                                </span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default CustomPrice;
